var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: ', ';\n  flex-direction: column;\n  input[type=\'number\']::-webkit-outer-spin-button,\n  input[type=\'number\']::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type=\'number\'] {\n    -moz-appearance: textfield;\n  }\n'], ['\n  display: ', ';\n  flex-direction: column;\n  input[type=\'number\']::-webkit-outer-spin-button,\n  input[type=\'number\']::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  input[type=\'number\'] {\n    -moz-appearance: textfield;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n\n  &.input-icon {\n    background-image: url(', ');\n  }\n\n  font-weight: ', ';\n  box-sizing: border-box;\n  background-position: right 12px center;\n  background-repeat: no-repeat;\n  border-radius: ', ';\n  border-width: ', ';\n  border-style: solid;\n  border-color: ', ';\n\n  background-image: url(', ');\n\n  font-size: ', ';\n  height: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  transition: all 0.25s ease-in-out;\n\n  margin-top: ', ';\n  margin-bottom: ', ';\n  width: ', ';\n  @media (max-width: 768px) {\n    margin-top: 4px;\n    margin-bottom: 4px;\n  }\n\n\n  &:hover {\n    border-color: ', ';\n  }\n\n  &.input-errors {\n    border-color: ', ';\n    &:hover {\n      border-color: ', ';\n    }\n    &:focus {\n      border-color: ', ';\n    }\n  }\n\n  &:focus {\n    box-shadow: 0 0.313rem 0.719rem rgba(122,123,151,.1), 0 0.156rem 0.125rem rgba(122,123,151,.06);\n  }\n\n  &:focus, &.filled:not(.input-errors) {\n    outline: none;\n    border: ', ' solid ', ';\n    };\n\n  &::placeholder {\n    color: #bbb;\n    font-weight: ', ';\n  }\n'], ['\n\n  &.input-icon {\n    background-image: url(', ');\n  }\n\n  font-weight: ', ';\n  box-sizing: border-box;\n  background-position: right 12px center;\n  background-repeat: no-repeat;\n  border-radius: ', ';\n  border-width: ', ';\n  border-style: solid;\n  border-color: ', ';\n\n  background-image: url(', ');\n\n  font-size: ', ';\n  height: ', ';\n  padding-left: ', ';\n  padding-right: ', ';\n  transition: all 0.25s ease-in-out;\n\n  margin-top: ', ';\n  margin-bottom: ', ';\n  width: ', ';\n  @media (max-width: 768px) {\n    margin-top: 4px;\n    margin-bottom: 4px;\n  }\n\n\n  &:hover {\n    border-color: ', ';\n  }\n\n  &.input-errors {\n    border-color: ', ';\n    &:hover {\n      border-color: ', ';\n    }\n    &:focus {\n      border-color: ', ';\n    }\n  }\n\n  &:focus {\n    box-shadow: 0 0.313rem 0.719rem rgba(122,123,151,.1), 0 0.156rem 0.125rem rgba(122,123,151,.06);\n  }\n\n  &:focus, &.filled:not(.input-errors) {\n    outline: none;\n    border: ', ' solid ', ';\n    };\n\n  &::placeholder {\n    color: #bbb;\n    font-weight: ', ';\n  }\n']);

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
import InputContainer from '../InputContainer';
import Label from '../Label';
import { setColour } from '../../Utils/colours';
import { resolveIcon } from '../../../utils';
import { withTheme } from 'styled-components';
import iconValid from './tick.svg';
import iconInvalid from './x.svg';
import { inputWeight } from '../../Theme/index';
var StyledInputTextContainer = styled.div(_templateObject, function (props) {
  return props.display ? props.display : 'flex';
});
var Input = styled.input(_templateObject2, function (props) {
  return props.icon;
}, function (props) {
  return inputWeight(props);
}, function (props) {
  return props.theme.radius;
}, function (props) {
  return props.theme.border_width;
}, function (props) {
  return props.validates === true && props.theme.colours.success.base || props.validates === false && props.theme.colours.danger.base || props.theme.colours.neutral.base;
}, function (props) {
  return props.validates === true && iconValid || props.validates === false && iconInvalid || '';
}, function (props) {
  return props.size === 'small' ? '16px' : '16px';
}, function (props) {
  return props.size === 'small' ? '32px' : '48px';
}, function (props) {
  return props.size === 'small' ? '16px' : '1rem';
}, function (props) {
  return props.size === 'small' ? '16px' : '1rem';
}, function (props) {
  return props.nomargin ? '0px' : '4px';
}, function (props) {
  return props.nomargin ? '0px' : '4px';
}, function (props) {
  return props.width ? props.width : 'auto';
}, function (props) {
  return props.theme.colours.primary.base;
}, function (props) {
  return props.theme.colours.danger.base;
}, function (props) {
  return props.theme.colours.danger.dark;
}, function (props) {
  return props.theme.colours.danger.dark;
}, function (props) {
  return props.theme.border_width;
}, function (props) {
  return setColour(props, 'borderColor', 'base');
}, function (props) {
  return inputWeight(props);
});

var InputText = function (_React$Component) {
  _inherits(InputText, _React$Component);

  function InputText(props) {
    _classCallCheck(this, InputText);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      filled: false
    };
    return _this;
  }

  InputText.prototype.handleChange = function handleChange(e) {
    if (this.props.onChange) {
      this.props.onChange(e);
    }

    this.setState({
      filled: e.target.value ? true : false
    });
  };

  InputText.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        label = _props.label,
        errors = _props.errors,
        hasError = _props.hasError,
        rest = _objectWithoutProperties(_props, ['label', 'errors', 'hasError']);

    var icon = resolveIcon(this.props.theme, this.props.icon);
    var hasErrors = hasError || errors !== undefined && errors.length > 0;
    var hasIcon = icon !== undefined;
    var classNames = [];
    var validates = this.props.validates || null;

    if (hasErrors) {
      validates = false;
      classNames.push('input-errors');
    }

    if (hasIcon) {
      classNames.push('input-icon');
    }

    if (this.state.filled) {
      classNames.push('filled');
    }

    var hasLabel = void 0;
    var forText = void 0;

    if (typeof label === 'string') {
      hasLabel = true;
      forText = label.replace(/[^a-zA-Z]+/g, '').toLowerCase() + Math.floor(Math.random() * 90 + 10);
    } else if ((typeof label === 'undefined' ? 'undefined' : _typeof(label)) === 'object') {
      hasLabel = true;
    } else {
      hasLabel = false;
      forText = Math.random().toString(36).substring(7).replace(/[^a-zA-Z]+/g, '');
    }

    return React.createElement(InputContainer, {
      minheight: this.props.minheight,
      nowrap: this.props.nowrap,
      display: this.props.display
    }, React.createElement(StyledInputTextContainer, {
      display: this.props.display,
      className: 'input-container'
    }, hasLabel && React.createElement(Label, {
      forText: forText
    }, label), React.createElement(Input, _extends({}, rest, {
      id: forText,
      nomargin: this.props.nomargin,
      icon: icon,
      validates: this.props.validates,
      className: classNames.join(' '),
      onChange: function onChange(e) {
        _this2.handleChange(e);
      },
      nowrap: true
    }))));
  };

  return InputText;
}(React.Component);

export default withTheme(InputText);